import { memo, useCallback } from 'react';
import Typography from '@mui/material/Typography';
import _map from 'lodash/map';
// Local files
import Item from './Item/Item';
import { StyledList } from './List.styled';
import ListSkeleton from 'components/Common/Feedback/ListSkeleton/ListSkeleton';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useSuperbillTasks from 'hooks/useSuperbillTasks';
import { superbillTasksSelectors } from "features/superbillTasks";

const SuperbillTasksList = ({ superbillAnalysisId }) => {
  const { getSuperbillTasks } = useSuperbillTasks();
  const { data, pagination } = useCustomSelector(superbillTasksSelectors.getSuperbillTasksData);
  const fetching = useCustomSelector(superbillTasksSelectors.superbillTasksIsFetching);

  const fetchSuperbillTasks = useCallback((id, offset) => {
    getSuperbillTasks({ id, offset });
  }, [getSuperbillTasks]);

  const handleScroll = ({ target: { scrollTop, scrollHeight, offsetHeight } }) => 
    (scrollTop + 65) >= scrollHeight - offsetHeight && pagination.total_count > pagination.count + pagination.offset && !fetching && fetchSuperbillTasks(superbillAnalysisId, pagination.limit + pagination.offset);

  return (
    <StyledList onScroll={handleScroll}>
      {_map(data, (item) => <Item key={item.id} {...item} />)}
      {fetching && <ListSkeleton />}
      {data.length === 0 && !fetching && <Typography sx={{ textTransform: 'uppercase', textAlign: 'center' }}>No tasks</Typography>}
    </StyledList>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <SuperbillTasksList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);